import { ReactNode } from "react";
import { useUserRoles } from "../../utilities/roleUtils";

interface RoleBasedAccessProps {
  allowedRoles: string[];
  children: ReactNode;
  fallback?: ReactNode;
}

const RoleBasedAccess: React.FC<RoleBasedAccessProps> = ({
  allowedRoles,
  children,
  fallback = null,
}) => {
  const { hasAnyRole } = useUserRoles();

  if (hasAnyRole(allowedRoles as any)) {
    return <>{children}</>;
  }

  return <>{fallback}</>;
};

export default RoleBasedAccess;